export const FIXED_IMAGE_HEIGHT = 372;
